<div class="download-banner d-flex">
    <div class="banner-title">
        <span class="highlight"> تطبيق مقارئ </span>
        جربه الآن - مجاناً
    </div>
    <div class="actions d-flex">
        <button class="action-btn filled-btn" (click)="goToApp()"> الذهاب إلى التطبيق </button>
        <button class="action-btn" (click)="downloadApp()"> حمل التطبيق </button>
    </div>

    <div class="close-btn" (click)="closeBanner()"><img src="../../../../assets/images/close.svg" alt="close"></div>
</div>